"use client";

import { useTheme } from "next-themes";
import { useHydrated } from "@/hooks/use-hydrated";

export default function LightModeNotice() {
    const { resolvedTheme } = useTheme();
    const hydrated = useHydrated();

    if (!hydrated || resolvedTheme !== "light") return null;

    return (
        <div className="w-full py-8 text-center text-sm font-[family-name:var(--font-dm-mono)]">
            Please turn dark mode back on
        </div>
    );
}
